import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import "../reading.css";
import { randGroup, randDelay, randNotif, UNLVDate } from "../utils";
import firebase from "./page/firebaseConfig";

function Quiz() {
  const [able, setAble] = React.useState(true);
  const [res, setRes] = React.useState(true);

  var user_group = "1-" + randGroup;
  console.log("Saved user group: ", user_group);

  // Changes based on notification group
  if (randNotif === 1) { 
    localStorage.setItem("notification_name","Low fear / High efficacy");
  } else if (randNotif === 2) { 
    localStorage.setItem("notification_name","Low fear / Low efficacy");
  } else if (randNotif === 3) { 
    localStorage.setItem("notification_name","High fear / High efficacy");
  } else if (randNotif === 4) { 
    localStorage.setItem("notification_name","High fear / Low efficacy");
  }

  window.onbeforeunload = function () {
    localStorage.clear();
  };

  if (randDelay === 1) {
    localStorage.setItem("time_group","During Task group");
  } else {
    localStorage.setItem("time_group","After Task group");
  }

  // For future reference, submit and display results button writes to firebae NOT 
  // the next button that pops up once the user presses submit and can see their answers 
  function validate() {
    setRes(false);
    hide_quiz();

    // Get the value of all of select tags
    try {
      var q1 = document.querySelector('input[name="q1_radio"]:checked').value;
    } catch {
      var q1 = null
    }
    try {
      var q2 = document.querySelector('input[name="q2_radio"]:checked').value;
    } catch {
      var q2 = null;
    }
    try {
      var q3 = document.querySelector('input[name="q3_radio"]:checked').value;
    } catch {
      var q3 = null;
    }
    try {
      var q4 = document.querySelector('input[name="q4_radio"]:checked').value;
    } catch {
      var q4 = null;
    }
    var q1_bool = false;
    var q2_bool = false;
    var q3_bool = false;
    var q4_bool = false;
    var score = 0;
    // Check to see if the user's select values are the same as the correct option id's
    if (q1 === "q1_a3") {
      q1_bool = true;
      score++;
    }
    if (q2 === "q2_a3") {
      q2_bool = true;
      score++;
    }
    if (q3 === "q3_a4") {
      q3_bool = true;
      score++;
    }
    if (q4 === "q4_a4") {
      q4_bool = true;
      score++;
    }
     // Display correct answers by changing the innerHTML of the previously empty div
    if (q1_bool === true) {
      document.getElementById("q1_check").innerHTML = "Question 1: Correct";
    } else {
      document.getElementById("q1_check").innerHTML = "Question 1: Incorrect";
      document.getElementById("d_q1").innerHTML = "What were the three abilities mentioned in the report that have persuaded consumers to experiment with generative AI applications?";
      document.getElementById("a_q1").innerHTML = "Correct choice: Write text, compose music, and create digital art";
      document.getElementById("q_no1").innerHTML = "Question 1";
    }
    if (q2_bool === true) {
      document.getElementById("q2_check").innerHTML = "Question 2: Correct";
    } else {
      document.getElementById("q2_check").innerHTML = "Question 2: Incorrect";
      document.getElementById("d_q2").innerHTML = "How is generative AI defined in this report?";
      document.getElementById("a_q2").innerHTML = "Correct choice: As applications typically built using foundation models";
      document.getElementById("q_no2").innerHTML = "Question 2";
    }
    if (q3_bool === true) {
      document.getElementById("q3_check").innerHTML = "Question 3: Correct";
    } else {
      document.getElementById("q3_check").innerHTML = "Question 3: Incorrect";
      document.getElementById("d_q3").innerHTML = "What is a “use case” as described in this report?";
      document.getElementById("a_q3").innerHTML = "Correct choice: Targeted application of generative AI to a specific business challenge with one or more measurable outcomes";
      document.getElementById("q_no3").innerHTML = "Question 3";
    }
    if (q4_bool === true) {
      document.getElementById("q4_check").innerHTML = "Question 4: Correct";
    } else {
      document.getElementById("q4_check").innerHTML = "Question 4: Incorrect";
      document.getElementById("d_q4").innerHTML = "What were the two lenses mentioned that can deliver value for organizations?";
      document.getElementById("a_q4").innerHTML = "Correct choice: Scanning use cases for generative AI across business functions and analyzing generative AI’s potential impact on work activities in hundreds of occupations";
      document.getElementById("q_no4").innerHTML = "Question 4";
    }
    document.getElementById("tot_score").innerHTML = "Total score: " + score + "/4";
    if (score === 1) {
      document.getElementById("inc_qs").innerHTML = "Correct Answer is displayed below";
    } else if (score > 1) {
      document.getElementById("inc_qs").innerHTML = "Correct Answers are displayed below";
    }

    localStorage.setItem("score",score);
  }

  // After 10 seconds enable the user to submit results, totals user interaction time to 4 min 10 sec
  useEffect(() => {
    const timer = setTimeout(() => {
      setAble(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  function setEndQuiz() {
    localStorage.setItem("quiz_end_time", UNLVDate);
    console.log("ending time = "+UNLVDate());
  }

  function sendToFirebase() {
    setEndQuiz();
    const db = firebase.firestore();
          // This document is meant to keep track of the user's
          // score while interacting with the platform
          db.collection("login_handler")
            .doc(localStorage.getItem("user_id"))
            .collection("AprilGroup1")
            .add({
              worker_id: localStorage.getItem("user_id"),
              unique_id: localStorage.getItem("unique_id"),
              group: randGroup,
              threat: localStorage.getItem("threat"),
              efficacy: localStorage.getItem("efficacy"),
              task_time_DTI: localStorage.getItem("task_time"),
              task_type: localStorage.getItem("task_type"),
              start_time: localStorage.getItem("home_icon_click_time"),
              time_end: UNLVDate(),
              time_MSN_display: localStorage.getItem("msn_start_time"),
              time_respond: localStorage.getItem("time_respond"),
              MSN_accept: localStorage.getItem("msn_accept"),
              security_setting: localStorage.getItem("security_setting"),
              time_setting: localStorage.getItem("setting_change_time"),
              performance_score: parseInt(localStorage.getItem("score")),
            })
            .then(function (docRef) {
              console.log("Document written with ID: ", docRef.id);
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
            });
  }
  // To the next developer that is gonna look at this, I am so sorry
  // I coudln't figure out how to format the radio button to the label, and
  // since the label was inline, it was the wrong width and to adjust the width
  // you had to bring it out of line with the radio button so i had to flex each 
  // individual radio button and label :(
  return (
    <div id="quiz_div" className="quiz-options ">
      <div id="quiz_results">
        <h1 id="heading"> </h1>
        <h3 id="q1_check"> </h3>
        <h3 id="q2_check"> </h3>
        <h3 id="q3_check"> </h3>
        <h3 id="q4_check"> </h3>
        <h3 id="tot_score"> </h3>
        <h2 id="inc_qs"> </h2>
        <h4 id="q_no1"> </h4>
        <p id="d_q1"> </p>
        <p id="a_q1"> </p>
        <h4 id="q_no2"> </h4>
        <p id="d_q2"> </p>
        <p id="a_q2"> </p>
        <h4 id="q_no3"> </h4>
        <p id="d_q3"> </p>
        <p id="a_q3"> </p>
        <h4 id="q_no4"> </h4>
        <p id="d_q4"> </p>
        <p id="a_q4"> </p>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <Button style={{ textTransform: "none", marginBottom: "1rem", marginTop: "-5rem"}} variant="contained" size="small" color="primary" disabled={res}>
        {/* <Link to="/post_survey" style={{ color: "white" }}> */}
        <Link  
          to={(randDelay === 1) ? "/post_survey" : "/after-task"} 
          style={{ color: "white "}}
          onClick={(randDelay === 1) ?  sendToFirebase : setEndQuiz}>
          Continue
        </Link>
      </Button>
      </div>
      <form id="quiz" name="quiz">
      <Button color="primary" variant="contained" onClick={validate} disabled={able} style={{marginBottom: "1rem"}}>
          Submit and Display Results
      </Button> 
        <h1 id="Sample_quiz_heading">Quiz</h1>
        <p><b>What were the three abilities mentioned in the report that have persuaded consumers to experiment with generative AI applications?</b></p>
        <div id="q1" name="q1" className="center-div">
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q1_radio" value="q1_a1" id="q1_a1" />
            </div>
            <div>
              <label htmlFor="q1_a1">  Write music, take pictures, and paint portraits</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q1_radio" value="q1_a2" id="q1_a2"/>
            </div>
            <div>
              <label htmlFor="q1_a2">  Compose orchestras, buy stocks, and write poetry</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q1_radio" value="q1_a3" id="q1_a3"/>
            </div>
            <div>
              <label htmlFor="q1_a3">  Write text, compose music, and create digital art</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment"> 
            <div>
              <input type="radio" name="q1_radio" value="q1_a4" id="q1_a4"/>
            </div>
            <div>
              <label htmlFor="q1_a4">  Paint portraits, compose orchestras, and write music</label>
            </div>
          </div>
          <br></br>
          <br></br>
        </div>
        <p><b>How is generative AI defined in this report?</b></p>
        <div id="q2" name="q2" className="center-div">
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q2_radio" value="q2_a1" id="q2_a1" />
            </div>
            <div>
              <label htmlFor="q2_a1">  As applications downloaded from the Google Play store</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q2_radio" value="q2_a2" id="q2_a2"/>
            </div>
            <div>
              <label htmlFor="q2_a2">  As applications downloaded from the Apple App store</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q2_radio" value="q2_a3" id="q2_a3"/>
            </div>
            <div>
              <label htmlFor="q2_a3">  As applications typically built using foundation models</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q2_radio" value="q2_a4" id="q2_a4"/>
            </div>
            <div>
              <label htmlFor="q2_a4">  As applications created for mobile devices</label>
            </div>
          </div>
          <br></br>
          <br></br>
        </div>
        <p><b>What is a “use case” as described in this report?</b></p>
        <div id="q3" name="q3" className="center-div">
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q3_radio" value="q3_a1" id="q3_a1"/>
            </div>
            <div>
              <label htmlFor="q3_a1">  The operating system of a generative AI application that allows consumers to use generative AI</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q3_radio" value="q3_a2" id="q3_a2"/>
            </div>
            <div>
              <label htmlFor="q3_a2">  An application that allows mobile users to simultaneously use multiple apps at the same time on a single device</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q3_radio" value="q3_a3" id="q3_a3"/>
            </div>
            <div>
              <label htmlFor="q3_a3">  Use of an application by a consumer on a mobile device, desktop computer, or laptop</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q3_radio" value="q3_a4" id="q3_a4"/>
            </div>
            <div>
              <label htmlFor="q3_a4">  Targeted application of generative AI to a specific business challenge with one or more measurable outcome</label>
            </div>
          </div>
          <br></br>
          <br></br>
        </div>
        <p><b>What were the two lenses mentioned that can deliver value for organizations?</b></p>
        <div id="q4" name="q4" className="center-div">
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q4_radio" value="q4_a1" id="q4_a1"/>
            </div>
            <div>
              <label htmlFor="q4_a1">  Creating a generative AI application that integrates augmented reality with the Metaverse and developing an autonomous vehicle for smart taxi services</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q4_radio" value="q4_a2" id="q4_a2"/>
            </div>
            <div>
              <label htmlFor="q4_a2">  Relying on Apple to develop an autonomous Apple vehicle that is controlled by an iPhone and establishing Tesla’s electric vehicle charging stations as the standard for electric vehicles</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q4_radio" value="q4_a3" id="q4_a3"/>
            </div>
            <div>
              <label htmlFor="q4_a3">  Developing generative AI applications in the healthcare sector and using robotic AI to perform surgeries to improve quality of life for hospital inpatients</label>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="button-alignment">
            <div>
              <input type="radio" name="q4_radio" value="q4_a4" id="q4_a4"/>
            </div>
            <div>
              <label htmlFor="q4_a4">  Scanning use cases for generative AI across business functions and analyzing generative AI’s potential impact on work activities in hundreds of occupations</label>
            </div>
          </div>
          <br></br>
          <br></br>
        </div>
        <br></br>
        <br></br>
    </form>
    </div>
  );
}

  function hide_quiz() {
    var x = document.getElementById("quiz");
    x.style.display = "none";
    var y = document.getElementById("quiz_results");
    y.style.visibility = "visible";
  }


export default Quiz;
